import React from "react";
const Gauge = () => {
  return (
    <div>
      <h1>Gauge</h1>
    </div>
  );
};
export default Gauge;
